/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Button, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IShowAdditionalInfoInput {
    canEdit: boolean;
    orderReference: string;
    orderNotes: string;
    requestedShippingDate: Date | null;
    resources: {
        editBtnLabel: string;
        orderReferenceDisplayLabel: string;
        orderNotesDisplayLabel: string;
        requestedShippingDateDisplayLabel: string;
        noRequestedShippingDateMessage: string;
    };
    onEdit(): void;
}

export interface IShowAdditionalInfo {
    showInfoProps: INodeProps;
    orderReference: React.ReactNode;
    orderNotes: React.ReactNode;
    requestedShippingDate: React.ReactNode;
    editButton?: React.ReactNode;
}

const dateFormat : Intl.DateTimeFormatOptions = { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
};

const getAdditionalInfo = ({
    canEdit, 
    orderReference, 
    orderNotes, 
    requestedShippingDate, 
    resources: { 
        editBtnLabel, 
        orderReferenceDisplayLabel,
        orderNotesDisplayLabel,
        requestedShippingDateDisplayLabel,
        noRequestedShippingDateMessage
    }, 
    onEdit 
}: IShowAdditionalInfoInput): IShowAdditionalInfo => ({
    showInfoProps: { className: 'lli-checkout-additional_info__selected-item' },
    orderReference: <span className='lli-checkout-additional_info__selected-order-reference lli-checkout-additional_info__item-newline'>
        <label>{orderReferenceDisplayLabel}: </label>{orderReference}<br/>
    </span>,
    orderNotes: <span className='lli-checkout-additional_info__selected-order-notes lli-checkout-additional_info__item-newline'>
        <label>{orderNotesDisplayLabel}: </label>{orderNotes}<br/>
    </span>,
    requestedShippingDate: <span className='lli-checkout-additional_info__selected-requested-shipping-date lli-checkout-additional_info__item-newline'>
        <label>{requestedShippingDateDisplayLabel}: </label>{(requestedShippingDate && requestedShippingDate.toLocaleDateString(undefined, dateFormat)) || noRequestedShippingDateMessage}
    </span>,
    editButton: canEdit && (
        <Button
            className='lli-checkout-additional_info__btn-edit' title={editBtnLabel} color='link'
            onClick={onEdit} >
            {editBtnLabel}
        </Button>
    )
});

export default getAdditionalInfo;
